// extracted by mini-css-extract-plugin
export default {"layout":"UniverseMeterQuery_layout__gUlYk","content":"UniverseMeterQuery_content__VXJij","empty":"UniverseMeterQuery_empty__J-8EZ","swiperBox":"UniverseMeterQuery_swiperBox__PRiVF"};